// FIXME: use real data from API
export function useAccountDetail() {
  return {
    shipTo: [
      'a9290617-73d6-4272-a3b8-143f2fa85bfb',
      '97248fb2-737a-4436-99d3-cb5c856d163c',
    ],
  };
}

export default useAccountDetail;
